import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactUs.css';


const INDUSTRY_OPTIONS = [
  'Advertising & Marketing',
  'Finance & Banking',
  'Healthcare',
  'Education',
  'Retail & E-commerce',
  'Information Technology',
  'Manufacturing',
  'Transportation & Logistics',
  'Hospitality & Tourism',
  'Non-profit & NGOs',
  'Telecommunications',
  'Real Estate & Construction',
  'Energy & Utilities'
];

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    companyName: '',
    industry: '',
    message: ''
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');

  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token || '');
    if (submitError) setSubmitError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setSubmitError('Please verify you are human 👋');
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');

    try {
      const emailjs = await import('@emailjs/browser');

      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        phoneNumber: formData.phoneNumber,
        company_name: formData.companyName,
        industry: formData.industry,
        message: formData.message,
        to_email: 'tedaringo628@gmail.com',
        'g-recaptcha-response': captchaToken
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setFormSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phoneNumber: '',
        companyName: '',
        industry: '',
        message: ''
      });
      recaptchaRef.current?.reset();
      setCaptchaToken('');

      setTimeout(() => setFormSubmitted(false), 5000);
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitError('Failed to send message. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-content">
          <h1>Contact Us</h1>
          <p className="availability">We are available weekdays from 8:00AM–5:00PM</p>
        </div>
        <div className="hero-background">
          <div className="circle-navy"></div>
          <div className="circle-light-blue"></div>
          <div className="circle-peach"></div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="contact-container">
          {/* Contact Person Card */}
          <div className="contact-image-card">
            <div className="contact-image">
              <img src="/images/contact1.jpg" alt="Customer support representative" />
            </div>
            <div className="contact-methods">
              <div className="contact-method-left">
                <div className="method-icon email-icon">
                  {/* email SVG */}
                </div>
                <div className="method-info">
                  <p className="method-label">Email Us</p>
                  <p className="method-value">chat@peakmobile.co.ke</p>
                </div>
              </div>
              <div className="contact-method-right">
                <div className="method-icon phone-icon">
                  {/* phone SVG */}
                </div>
                <div className="method-info">
                  <p className="method-label">Call Us</p>
                  <p className="method-value">+254 759 422 480</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-card">
            <h2>Contact Us – Let’s Talk Customer Rewards</h2>

            {formSubmitted && (
              <div className="form-success">
                Your message has been sent successfully! We'll get back to you soon.
              </div>
            )}
            {submitError && (
              <div className="form-error">{submitError}</div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <div className="title-label">
                    <label htmlFor="name">Name*</label>
                  </div>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Bryan"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="title-label">
                    <label htmlFor="email">Email*</label>
                  </div>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="bryan@gmail.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <div className="title-label">
                    <label htmlFor="phoneNumber">Phone Number*</label>
                  </div>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder="0712345678"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <div className="title-label">
                    <label htmlFor="companyName">Company Name*</label>
                  </div>
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    placeholder="Your company name"
                    value={formData.companyName}
                    onChange={handleChange}
                    required
                  />
                </div>
               <div className="form-group">
                <div className="title-label">
                  <label htmlFor="industry">Industry*</label>
                </div>
                <select
                  id="industry"
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    -- Select an industry --
                  </option>
                  {INDUSTRY_OPTIONS.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>

              </div>

              <div className="form-group">
                <div className="title-label">
                  <label htmlFor="message">Message*</label>
                </div>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Write a message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* reCAPTCHA */}
              <div className="captcha-wrapper">
                <ReCAPTCHA
                style={{"marginTop": "20px"}}
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={handleCaptchaChange}
                />
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending…' : 'Send Inquiry'} <span className="arrow">→</span>
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
